import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotFoundComponent } from './shared/miscellaneous/not-found/not-found.component';
import { CalendarSearchComponent } from './calendar-search/calendar-search.component';
import { CountryContentComponent } from './country-content/country-content.component';
import { HomeMapComponent } from './home/home-map.component';
import { AfriqueComponent } from './region-content/region-component/afrique.component';
import { AmeriqueComponent } from './region-content/region-component/amerique.component';
import { EuropeComponent } from './region-content/region-component/europe.component';
import { CaraibesComponent } from './region-content/region-component/caraibes.component';
import { AsieComponent } from './region-content/region-component/asie.component';
import { AmeriqueCentraleComponent } from './region-content/region-component/amerique-centrale.component';
import { AmeriqueDuSudComponent } from './region-content/region-component/amerique-du-sud.component';
import { AmeriqueDuNordComponent } from './region-content/region-component/amerique-du-nord.component';
import { MoyenOrientComponent } from './region-content/region-component/moyen-orient.component';
import { OceanAtlantiqueComponent } from './region-content/region-component/ocean-atlantique.component';
import { OceanIndienComponent } from './region-content/region-component/ocean-indien.component';
import { OceanPacifiqueComponent } from './region-content/region-component/ocean-pacifique.component';


const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'world-informations',
      component: DashboardComponent,
    },
    {
      path: 'calendar-search',
      component: CalendarSearchComponent,
    },
    {
      path: 'home-map',
      component: HomeMapComponent,
    },
    {
      path: 'afrique',
      component: AfriqueComponent,
    },
    {
      path: 'amerique',
      component: AmeriqueComponent,
    },
    {
      path: 'amerique-du-nord',
      component: AmeriqueDuNordComponent,
    },
    {
      path: 'amerique-du-sud',
      component: AmeriqueDuSudComponent,
    },
    {
      path: 'amerique-centrale',
      component: AmeriqueCentraleComponent,
    },
    {
      path: 'asie',
      component: AsieComponent,
    },
    {
      path: 'caraibes',
      component: CaraibesComponent,
    },
    {
      path: 'europe',
      component: EuropeComponent,
    },
    {
      path: 'moyen-orient',
      component: MoyenOrientComponent,
    },
    {
      path: 'ocean-atlantique',
      component: OceanAtlantiqueComponent,
    },
    {
      path: 'ocean-indien',
      component: OceanIndienComponent,
    },
    {
      path: 'ocean-pacifique',
      component: OceanPacifiqueComponent,
    },
    {
      path: 'country-content',
      component: CountryContentComponent,
    },
    {
      path: '',
      redirectTo: 'home-map',
      pathMatch: 'full',
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
